/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_3_Steps_1Inputs */

const en_gc_search_guides_gridcraft_vs_excel_sections_3_steps_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_3_Steps_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make the same small edit in separate copies in both tools. Compare the displayed result and the formula text. Record any difference rather than explaining it away as a formatting issue.`)
};

const zh_gc_search_guides_gridcraft_vs_excel_sections_3_steps_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_3_Steps_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在两款工具的独立副本中做同一项小修改，比较显示结果与公式文本。记录差异，不要直接将其归为格式问题。`)
};

/**
* | output |
* | --- |
* | "Make the same small edit in separate copies in both tools. Compare the displayed result and the formula text. Record any difference rather than explaining it..." |
*
* @param {Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_3_Steps_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_vs_excel_sections_3_steps_1 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_3_Steps_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_3_Steps_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_vs_excel_sections_3_steps_1(inputs)
	return zh_gc_search_guides_gridcraft_vs_excel_sections_3_steps_1(inputs)
});
export { gc_search_guides_gridcraft_vs_excel_sections_3_steps_1 as "gc.search_guides.gridcraft_vs_excel.sections.3.steps.1" }